import { render, staticRenderFns } from "./PhoneNumberCommitTransaction.vue?vue&type=template&id=55a3dd1b"
import script from "./PhoneNumberCommitTransaction.vue?vue&type=script&lang=js"
export * from "./PhoneNumberCommitTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports